var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.6416 6.20001L9.99993 10.4583L17.3083 6.22501M9.99993 18.0083V10.45",
    stroke: "#377DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.27454 2.06666L3.82454 4.54166C2.81621 5.09999 1.99121 6.49999 1.99121 7.64999V12.3583C1.99121 13.5083 2.81621 14.9083 3.82454 15.4667L8.27454 17.9417C9.22454 18.4667 10.7829 18.4667 11.7329 17.9417L16.1829 15.4667C17.1912 14.9083 18.0162 13.5083 18.0162 12.3583V7.64999C18.0162 6.49999 17.1912 5.09999 16.1829 4.54166L11.7329 2.06666C10.7745 1.53332 9.22454 1.53332 8.27454 2.06666Z",
    stroke: "#377DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.1671 11.0333V7.98332L6.25879 3.41666",
    stroke: "#377DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.aade92bb2a7009497bf668ba7c573c17.svg";
export { ForwardRef as ReactComponent };